import { render, staticRenderFns } from "./StorePromotion.vue?vue&type=template&id=37f8b614&scoped=true"
import script from "./StorePromotion.vue?vue&type=script&lang=js"
export * from "./StorePromotion.vue?vue&type=script&lang=js"
import style0 from "./StorePromotion.vue?vue&type=style&index=0&id=37f8b614&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f8b614",
  null
  
)

export default component.exports